var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ hidden: !_vm.initialThemeSet }},[_c('Nuxt'),_vm._v(" "),_c('CookiesBanner'),_vm._v(" "),_c('CookiesModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }